<template>
  <div class="new-slider">
    <VueSlickCarousel v-bind="settings" class="slider-new">
        <div v-for="(slide,i) in slides1" :key="i">
           <div class="car_item">
            <div class="card_vue1" :id="'slide' + i">
              <p>{{texts1[i]}}</p>
              <p>{{names[i]}}</p>
            </div>  
          </div>
        </div>
    </VueSlickCarousel>
  </div>
   
</template>

<script>
  import VueSlickCarousel from 'vue-slick-carousel'
  import 'vue-slick-carousel/dist/vue-slick-carousel.css'
  import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'


  export default {
    props: ['vertical', 'verticalS', 'items', 'rows','controls','texts'],
    name: 'Carousel_cards',
     components: {
    VueSlickCarousel
  },
    data: () => ({
    settings: {
  "slidesToShow":1,
  "slidesToScroll": 1,
  "arrows": false,
  "dots": true,
  "dotsClass": "slick-dots custom-dot-class",
  "autoplay": true,
  "speed": 2000,
  "autoplaySpeed": 5000,

    "responsive": [
    {
    "breakpoint": 1310,
      "settings": {
        "slidesToShow": 1,
        "slidesToScroll": 1,
      }
    },
	{
      "breakpoint": 500,
      "settings": {
        "slidesToShow": 1,
        "slidesToScroll": 1,
      }
    },
  ]
    },
    slides1: [
      "1",
      "2",
      "3",
      "4",
      "5"
    ],
    texts1: [
      "Δίπλα στις λέξεις άνθρωπος και επιστήμονας θα έβαζα το όνομα του καλύτερου γιατρού που έχω γνωρίσει: Δημήτρης Τσιρώνης. Σας ευχαριστώ για όλα.",
      "Απλά ο καλύτερος ιατρός σε επίπεδο γνώσεων, επιστημονικής κατάρτισης και ανθρώπινου χαρακτήρα! Επαγγελματίας με τα όλα του!!",
      "Ένας από τους πιο εξαίρετους γιατρούς που έχω γνωρίσει, ενημερωμένος στον τομέα του και πάνω από όλα καλός άνθρωπος! Συνέχισε την καλή δουλειά!",
      "Αρίστος επαγγελματίας, και βαθιά καταρτισμένος, με πολυετή εκπαίδευση και εμπειρία στην χειρουργική του Μαστού.",
      "Very diligent professional and knowledgable practitioner!!!!",
    ],
    names:[
      "Βούλα Γ.",
      "Μανώλης Α.",
      "Γιώργος Δ.",
      "Γιώργος Β.",
      "Yiannis A."
    ]
    })
  }
</script>

<style>
  .fade-in {
    width: 100px;
    height: 100px;
    opacity: 0.00;
    -webkit-transition: 1s all ease-in-out;
    -moz-transition: 1s all ease-in-out;
    -o-transition: 1s all ease-in-out;
    transition: 1s all ease-in-out;
  }

  .fade-in:hover {
    opacity: 1.00;
  }
  .card_vue1{
    background: #a71d54;
    padding: 200px;
    height: 450px;
    margin-left: auto;
    margin-right: auto;
    color: #fff;
    margin-bottom:20px;
    background-size: cover;
    position: relative;
    width: 98%;
  }
  .card_vue1 p{
    font-size:16px;
    color:rgb(121 121 121);
    padding-bottom:25px;
  }
  .card_vue1 h2{
    font-size: 40px;
    color:rgb(0 0 0);
  }
  .card_vue1 h3{
    font-size: 15px;
    color:rgb(114 133 144);
    padding-bottom:15px;
  }
.slider-new h2, .slider-new h3,.slider-new p {
	font-family: 'Oswald-Light' !important; 
	font-weight:300 !important;
	margin-bottom:0px !important;
}
.slider-new h2{
	font-style:italic !important;
}

  .slider-new .slick-next{
    background: #a71d54 !important;
    border-radius: 0% !important;
    color: #a71d54 !important;
    width: 40px;
    height: 40px; 
    background: url('https://vue.anvetogroup.com/wp-content/uploads/2022/11/right.png'), transparent !important;
    background-size: cover !important;
    border:2px solid #a71d54 !important;
    position: absolute;
    left: 50.4%;
    z-index: 999;
    margin-top: -70px;
    top: 100%;
  }
  .slider-new .slick-next:hover{
    background: url('https://vue.anvetogroup.com/wp-content/uploads/2022/12/right1.png'), #a71d54 !important;
    background-size: cover !important;
  }
  .slider-new .slick-prev{
    background: #a71d54 !important;
    border-radius: 0% !important;
    color: #a71d54 !important;
    height: 40px;
    width: 40px;
    background: url('https://vue.anvetogroup.com/wp-content/uploads/2022/11/left.png') !important;
    background-size: cover !important;
    border:2px solid #a71d54 !important;
    position: absolute !important;
    left: 48.3% !important;
     z-index: 999 !important;
     margin-top: -70px !important;
     top: 100% !important;
  }
  .slider-new .slick-prev:hover{
    background: url('https://vue.anvetogroup.com/wp-content/uploads/2023/01/left1.png'), #a71d54 !important;
    background-size: cover !important;
  }
  .slick-slider{
    margin-left: 0px !important;
    margin-right: 0px !important;
    padding-top: 50px;
    cursor: pointer;
    
  }
  .side-info{
    padding:50px 25px !important;
    background-color: rgba(255, 255, 255, 0.9) !important;
    width: 15.7vw !important;
    height: 100% !important;
    position: absolute !important;
    left: 0px !important;
    top:0px !important;
    opacity: 0 !important;
  }

  .slick-current .side-info{
    opacity: 1 !important;
  }
  .side-info a{
    background-color: #728590;
    border: none;
    color: white;
    padding: 10px 35px;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    font-size: 16px;
    border-radius: 5px;
    font-weight: bold;
  }
  .side-info hr{
    border: 2px solid rgb(179 190 195);
    border-radius: 0px;
    width: 50px;
    margin:25px 0;
  }
 @media only screen and (max-width: 1750px) {
	.card_vue1{
		height:500px !important;
	}
  }
 @media only screen and (max-width: 1550px) {
	.slider-new .slick-prev{
		left: 48.2% !important;
	}
  }
 @media only screen and (max-width: 1400px) {
	.card_vue1 h2 {
		font-size: 30px;
	}
	.card_vue1 p {
		font-size: 15px;
	}
	.slider-new .slick-prev {
		left: 47.5% !important;
	}
  }
 @media only screen and (max-width: 1350px) {
	.card_vue1{
		height:550px !important;
	}
  }
 @media only screen and (max-width: 1310px) {
	.card_vue1{
		height:450px !important;
	}
	.side-info {
		width: 25vw !important;
	}
	.slider-new .slick-prev {
		left: 26.7% !important;
	}
	.slider-new .slick-next {
		left: 29.8% !important;
	}
  }

 @media only screen and (max-width: 1300px) {	
	.new-slider .slick-slider {
		max-width:100% !important;
		width:100% !important;
	}
  }
@media only screen and (max-width: 1150px) {	
	.side-info {
		width: 30vw !important;
	}
	.slider-new .slick-prev {
		left: 32% !important;
	}
	.slider-new .slick-next {
		left: 35.5% !important;
	}
 }
@media only screen and (max-width: 1150px) {	
	.side-info {
		width: 30vw !important;
	}
	.slider-new .slick-prev {
		left: 32% !important;
	}
	.slider-new .slick-next {
		left: 35.5% !important;
	}
 }
@media only screen and (max-width: 1050px) {	
	.slider-new .slick-prev {
		left: 32% !important;
	}
	.slider-new .slick-next {
		left: 35.8% !important;
	}
}
@media only screen and (max-width: 900px) {	
	.slider-new .slick-prev {
		left: 32.5% !important;
	}
	.slider-new .slick-next {
		left: 36.4% !important;
	}
}
@media only screen and (max-width: 800px) {	
	.slider-new .slick-prev {
		left: 33% !important;
	}
	.slider-new .slick-next {
		left: 37.2% !important;
	}
}
@media only screen and (max-width: 750px) {	
	.side-info {
		width: 35vw !important;
	}
	.slider-new .slick-prev {
		left: 37.4% !important;
	}
	.slider-new .slick-next {
		left: 43% !important;
	}
}
@media only screen and (max-width: 650px) {	
	.side-info {
		width: 40vw !important;
	}
	.slider-new .slick-prev {
		left: 42.6% !important;
	}
	.slider-new .slick-next {
		left: 48.9% !important;
	}
}
@media only screen and (max-width: 550px) {	
	.card_vue1{
		height:520px !important;
	}
	.slider-new .slick-prev {
		left: 43% !important;
	}
	.slider-new .slick-next {
		left: 49.8% !important;
	}
	.side-info a{
		padding:10px 30px !important;
	}
}
@media only screen and (max-width: 500px) {	
	.card_vue1{
		height:540px !important;
	}
	.slider-new .slick-next {
		left: 49.8% !important;
	}
	.slider-new .slick-prev {
		left: 42% !important;
	}
	.side-info a{
		font-size:14px !important;
	}
	.side-info {
		width: 48.8vw !important;
	}
}
@media only screen and (max-width: 400px) {	
	.slider-new .slick-next {
		left: 49% !important;
	}
	.slider-new .slick-prev {
		left:39% !important;
	}
}


@media only screen and (max-width: 400px) {	
	.card_vue1 h2 {
		font-size: 20px;
	}
	.side-info a {
		padding: 10px 20px !important;
	}
}
@media only screen and (max-width: 340px) {	
	.side-info {
		width: 54vw !important;
	}
	.slider-new .slick-next {
		left: 55% !important;
	}
	.slider-new .slick-prev {
		left:43% !important;
	}
}
  
</style>